import React, { Component } from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import withMobileDialog from "@material-ui/core/withMobileDialog";
import RecordPagination from "../../utils/RecordsPagination";

import {
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
} from "@material-ui/core";
import { appHelpers } from "../../_helpers";
const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Poppins', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  },
  tableStyle: {
    padding: 0
  },
  column: {
    wordWrap: "break-word",
    fontSize: "0.77rem"
  }
};

const FlightTableStructure = ({ classes, flights, handleClickOpen, pageIndex }) => (
  <Table className={classes.table} aria-labelledby="tableTitle">
    <TableHead className={classes.negativeColor} color="primary">
      <TableRow>
        <TableCell padding="none">S/N</TableCell>
        <TableCell padding="none">Airline</TableCell>
        <TableCell >Flight No</TableCell>
        <TableCell >Flight Date</TableCell>
        {/*<TableCell padding="none">Departure</TableCell>*/}
        {/*<TableCell padding="none">Destination</TableCell>*/}
        <TableCell padding="none">Total Passengers</TableCell>
        <TableCell padding="none">Billable Passengers</TableCell>
        <TableCell >Departure Airports</TableCell>
        <TableCell padding="none">Destination Airports</TableCell>
        {/* <TableCell padding="none">PSC (Naira)</TableCell> */}
        <TableCell >Action</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {flights.map((item, key) => {
        return (
          <TableRow hover key={key}>
            <TableCell  className={`${classes.column}`}>{pageIndex + key}</TableCell>
            <TableCell  padding="none" className={`${classes.column} text-capitalize`}>{item.Airline}</TableCell>
            <TableCell component="th" className={`${classes.column}`}>
              {item.FlightNo}
            </TableCell>
            <TableCell padding="none" className={`${classes.column}`}>{appHelpers.formatDateSpecific(
              item.DepartureDate,
              "MMM DD, YYYY"
            )}
            </TableCell>
            {/*<TableCell padding="none">{item.DepartureAirport.Name}</TableCell>*/}
            {/*<TableCell padding="none">{item.DestinationAirport.Name}</TableCell>*/}
            <TableCell padding="none" className={`${classes.column}`}>{appHelpers.numberWithCommasOnly(item.PassengerCount)}</TableCell>
            <TableCell padding="none" className={`${classes.column}`}>
              {appHelpers.numberWithCommasOnly(item.BillablePassenger)}
            </TableCell>
            <TableCell  className={`${classes.column} text-capitalize`}> {item.DepartureAirportName}</TableCell>
            <TableCell padding="none" className={`${classes.column} text-capitalize`}> {item.DestinationAirportName}</TableCell>
            <TableCell  className={`${classes.column}`}>
              <span
                onClick={() => handleClickOpen(item)}
                style={{ cursor: "pointer", color: "#dd2735" }}
              >
                View
                      </span>
            </TableCell>
          </TableRow>
        );
      })}
    </TableBody>
  </Table>
);

class FlightsTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      flight: false
    };
  }

  handleClickOpen = (flight) => {
    this.setState({ open: true });
    this.setState({ flight });
    this.props.fetchFlightPassengers(flight.Id);
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  printFlightData = () => { };

  downloadFlightData = () => { };

  render() {
    const { classes, totalFlightCounts, flights, fetchFlights, currentPage, pageSize, handleModal } = this.props;
    const pageIndex = (pageSize * (currentPage - 1)) + 1;
    return (
      <div>
        <div >
          <RecordPagination
            fetchMore={fetchFlights} totalCount={totalFlightCounts}
            pageSize={pageSize} currentPage={currentPage}
            target={
              <FlightTableStructure classes={classes} pageIndex={pageIndex} handleClickOpen={handleModal} flights={flights}
              />}
          />
        </div>
      </div>
    );
  }
}

export default withMobileDialog()(withStyles(styles)(FlightsTable));



// WEBPACK FOOTER //
// ./src/views/AirlinesPassenger/FlightsTable.jsx